import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import SelectUser from './SelectUser';
import MenuContent from './MenuContent';
import CardAlert from './CardAlert';
import OptionsMenu from './OptionsMenu';
import { useEffect, useState } from 'react';
import { getUserDetails } from '../api/auth';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export default function SideMenu({role}) {

  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await getUserDetails();
        setUser(user);
      } catch (error) {
        console.error('Error fetching user details:', error.message);
      }
    };

    fetchUser();
  }
  , []);

  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          mt: 'calc(var(--template-frame-height, 0px) + 4px)',
          p: 1.5,
        }}
      >
        {/* Display Logo from the public folder */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center', // Centers the content horizontally
            alignItems: 'center', // Centers the content vertically
            mt: 'calc(var(--template-frame-height, 0px) + 4px)', // Keep the original margin top
            p: 1.5,
            height: '100%', // Ensure the Box takes the full height
          }}
        >
          <img 
            src="/logo.png" 
            alt="Logo" 
            style={{ width: '80%', height: 'auto' }} 
          />
        </Box>

      </Box>

      <Divider />
      
      <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <MenuContent role={role} />
      </Box>
      <Divider></Divider>
      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: 'center',
        }}
      >
        <Avatar
          sizes="small"
          alt={user?.email == 'romanrico950424@gmail.com' ? 'Barbershop' : 'Rico'}
          src="/static/images/avatar/7.jpg"
          sx={{ width: 36, height: 36 }}
        />
        <Box sx={{ mr: 'auto' }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
            {user?.email == 'romanrico950424@gmail.com' ? 'Barbershop' : 'Rico'}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            {user?.email ? user.email.slice(0, 20) : ''}
          </Typography>
        </Box>
        <OptionsMenu />
      </Stack>
    </Drawer>
  );
}
